import React from 'react';
import ModalImage from 'react-modal-image';

function getFileType(uri) {
    const extension = uri.split('.').pop().toLowerCase();
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(extension)) {
        return 'image';
    } else {
        return 'unknown';
    }
}

const NoteAttachment = ({ attachmentUri }) => {
    if (!attachmentUri) {
        return null;
    }

    const fileType = getFileType(attachmentUri);

    if (fileType === 'image') {
        return (
            <div style={{ maxWidth: '150px', margin: '10px 0' }}>
                <ModalImage
                    small={attachmentUri}
                    large={attachmentUri}
                    alt="Image Attachment"
                    hideDownload={true}
                    hideZoom={true}
                />
            </div>
        );
    } else {
        return (
            <div>
                <p> Attachment:
                <a style={{ marginLeft: 2 }} href={attachmentUri} target="_blank" rel="noopener noreferrer">
                     {attachmentUri?.substring(attachmentUri.lastIndexOf('/') + 1) || 'none'}
                </a>
                </p>
            </div>
        );
    }
}

export default NoteAttachment;